import React from 'react'

const Header = () => {
  return (
    <div className='text-light_blue text-4xl font-semibold h-32 flex items-center'>Weather App</div>
  )
}

export default Header